export default {
  methods: {
    moneyformat(value) {
      return value !== null
        ? parseFloat(value)
            .toLocaleString('lt', {
              style: 'currency',
              currency: 'EUR',
              useGrouping: true,
            })
            .split('€')[0]
            .replace('.', ',')
        : '0,00'
    },
    noSpecialChar(name) {
      return name ? name.replaceAll(/(\\|\/|:|\*|\?|"|\<|\>|\|)+/g, '-') : ''
    },
    noDiacritic(name) {
      return name ? name.normalize('NFD').replace(/\p{Diacritic}/gu, '') : ''
    },
    safeFileName(name) {
      if (!name) {
        return ''
      }
      name = this.noSpecialChar(name)
      name = this.noDiacritic(name)
      return name
    },
    signFileName(name) {
      return this.safeFileName(name)
    },
    // bytesToSize(bytes, decimals = 1) {
    //   var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    //   if (bytes == 0) return '0 Byte'
    //   const dm = decimals < 0 ? 0 : decimals;
    //   const i = Math.floor(Math.log(bytes) / Math.log(1024));
    //   return parseFloat((bytes / Math.pow(1024, i)).toFixed(dm)) + ' ' + sizes[i];
    // },
     bytesToSize(bytes) {
      if (bytes == 0) return '0 Byte'
      return `${parseFloat(bytes / 1024).toFixed(0)} KB`
    },
  },
}
